module.exports = __webpack_public_path__ + "img/lugares-1.9d9aa8e5.png";